
import { Component } from '@angular/core';
import { AiSearchService } from './chatgpt-ai-search.service';

@Component({
  selector: 'app-ai-search',
  templateUrl: './chatgpt-ai-search.component.html',
  styleUrls: ['./chatgpt-ai-search.component.scss']
})
export class AiSearchComponent {

  query = '';
  results: any[] = [];
  loading = false;

  constructor(
    private ai: AiSearchService
  ) {}

  doSearch(): void {

    if (!this.query) {
      return;
    }

    this.loading = true;

    this.ai.search(this.query)
      .subscribe({
        next: (res) => {
          this.results = res;
          this.loading = false;
        },
        error: (err) => {
          console.error(err);
          this.loading = false;
        }
      });
  }

  getRelevanceLabel(score: number): string {
  if (score >= 2.2)return 'Excel·lent coincidència';
  if (score >= 1.7)return 'Molt rellevant';
  if (score >= 1.2)return 'Rellevant';
  if (score >= 0.9)return 'Possible relació';
  return 'Baixa rellevància';
}

  getRelevanceClass(score: number): string {
    if (score >= 2.2)return 'r-exacte';
    if (score >= 1.7)return 'r-molt';
    if (score >= 1.2)return 'r-mitja';
    if (score >= 0.9)return 'r-baixa';
    return 'r-soroll';
  }

  
downloadCSV(): void {
  const rows = this.results.map(r => ({
    id: r.origen_id,
    titol: r.titol,
    score: r.score,
    tipus: r.source_type,
    contingut: r.contingut
  }));
  const headers = Object.keys(rows[0]);
  const csv = [
    headers.join(','),
    ...rows.map(row =>
      headers.map(h => {
        const value = String(row[h] ?? '')
          .replace(/"/g, '""');
        return `"${value}"`;
      }).join(',')
    )
  ].join('\n');
  const blob = new Blob(
    [csv],
    { type: 'text/csv;charset=utf-8;' }
  );
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'ai-search.csv';
  a.click();

  window.URL.revokeObjectURL(url);
 }
}